import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DashboardService } from 'src/app/services/dashboard.service';
import { DatePickerDialogComponent } from '../date-picker-dialog/date-picker-dialog.component';
import { DatePickerModel } from '../date-picker-dialog/date-picker.model';
import { DateDialogComponent } from '../date-dialog/date-dialog.component';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-date-component-renderer',
  templateUrl: './date-component-renderer.component.html',
  styleUrls: ['./date-component-renderer.component.scss']
})
export class DateComponentRendererComponent implements OnInit,OnDestroy {
  @Input() isGraphDataChange;
  @Input() isOrderFilter:boolean=false;
  @Input() position:boolean
  @Input() isKpiDashboardId;
  @Input() isNetYard: boolean = false;
  @Input() isGraphCollection:boolean = false;
  @Input() isKpiSalesGraph:boolean=false;
  @Output() dateFilterOutput: EventEmitter<any> = new EventEmitter();
  @Input() winningBuyBox: boolean = false;
  @Input() repriceActivity: boolean = false;
  @Input() competition: boolean = false;
  @Input() isSales: boolean = false;
  private _currentDateFilter: DatePickerModel;
  @Input() priceyardDashboard: boolean = false;
  private destroy$ = new Subject<void>();
  dialogRef:any;
  spinner:boolean =false;
  label:string;
  get currentDateFilter(): DatePickerModel {
    return this._currentDateFilter;
  }

  @Input() set currentDateFilter(date: DatePickerModel) {    
    if (date) {
      this._currentDateFilter = date;

      const dateString = `${this.datePipe.transform(
        this.currentDateFilter.from,
        "M/d/yy"
      )} - ${this.datePipe.transform(this.currentDateFilter.to, "M/d/yy")}`;
      let displayDate
      if(this.page == 'sales-trends'){
         displayDate = this.label
      }else{
         displayDate =
        date.label && date.label !== "custom" ? date.label : dateString;
      }
      this.dateFilterButtonText = displayDate;
      if(this.isOrderFilter){
        this.dateFilterOutput.emit({selectedDate:date,dialogRef:this.dialogRef,spinner:this.spinner});
      } else {
        this.dashboardService.selectedDate$.next({startDate:date.from.toDateString(),endDate:date.to.toDateString(),
          isGraphDataChange:this.isGraphDataChange,label:this.dateFilterButtonText,page:this.page,isKpiSalesGraph:this.isKpiSalesGraph,isKpiDashboardId: this.isKpiDashboardId ? this.isKpiDashboardId : '', isNetYard: this.isNetYard,isGraphCollection:this.isGraphCollection,dialogRef:this.dialogRef,spinner:this.spinner,
          isWinningBuyBox: this.winningBuyBox, isRepriceActivity: this.repriceActivity, isCompetition: this.competition, isSales: this.isSales}); 
      }     
    }
  }
  dateFilterButtonText: string;
  @Input() page;

  constructor
  (
    private dialog: MatDialog,
    private datePipe: DatePipe,
    private dashboardService:DashboardService
  ) { }

  ngOnInit(): void {
    if(this.page == 'sales-trends'){
      this.dateFilterButtonText = 'Weekly'
    }
  }

  openDateDialog = (e: MouseEvent) => {
    if(this.page === 'sales-trends'){
      this.dialog
      .open(DateDialogComponent, {
        width: "450px",
        position: this.getDialogRightPosition(e),
        data: {data: this.currentDateFilter, hideResetbtn:this.isOrderFilter ? false :true,
          callBackFn: (dialogRef, data,spin) => {
            this.dialogRef = dialogRef;
            this.spinner = spin;
            this.label = data.selectedLabel
            this.currentDateFilter=data 
          }},
      })
    } else
    this.dialog
      .open(DatePickerDialogComponent, {
        width: "450px",
        position: this.getDialogRightPosition(e),
        data: {data: this.currentDateFilter, hideResetbtn:this.isOrderFilter ? false :true,
          callBackFn: (dialogRef, data,spin) => {
            this.dialogRef = dialogRef;
            this.spinner = spin;
            this.currentDateFilter=data;            
          }},
      })
  };

  getDialogRightPosition(e: MouseEvent) {
    const target = e.target as any;
    const targetPosision = target.getBoundingClientRect();
  if(this.isGraphDataChange)
    return {
      right: window.innerWidth - targetPosision.right + "px",
      bottom: targetPosision.top - 200 + "px",
    };
  else if(this.position){
    return {
      right: window.innerWidth - targetPosision.right - 350 + "px",
      bottom: targetPosision.top + 190 + "px",
    };
  } else if(this.isKpiSalesGraph){
    return {
      right: window.innerWidth - targetPosision.right + 130 + "px",
      bottom: targetPosision.top - 50+ "px",
      left:targetPosision.top - 10 + "px",
    };
  } else if(this.priceyardDashboard){
    return {
      right: "130px",
      top: "408px",
    }
  } else{
    return {
      right: window.innerWidth - targetPosision.right + "px",
      top: targetPosision.top + 30 + "px",
    };
  }}

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

}
